module.exports = __webpack_public_path__ + "static/media/pr-9.bd991db2.jpeg";